module.exports = __webpack_public_path__ + "static/NationalWeb-Light-dd6c53b31add927304e8460545b6afd3.woff2";